module.exports = __webpack_public_path__ + "static/media/portfolio1.d1259a01.png";